module.exports = __webpack_public_path__ + "static/media/m-blog-2.5263da30.jpg";